import { Workbook } from 'exceljs'
import moment from 'moment'
import { calculate_Adjustments } from '../pages/Reports/Adjustments'
import { convertToGST_Purchase_Report } from '../pages/Reports/Purchase'
import { convertToGST_Sales_Report } from '../pages/Reports/Sales'
import db from './db'

/**
 * Create a new workbook
 * @returns {Workbook} workbook
 */
function createWorkbook() {
  const workbook = new Workbook()
  workbook.creator = `Billin' Inc`
  workbook.created = new Date()
  workbook.modified = new Date()

  workbook.styles = {
    title: {
      alignment: {
        horizontal: 'center',
        vertical: 'center'
      },
      font: {
        bold: true,
        size: 18
      }
    }
  }
  return workbook
}

/**
 * Add a new worksheet to the workbook
 * @param {Workbook} workbook 
 * @param {string} name 
 */
function addSheet(workbook, name) {
  const sheet = workbook.addWorksheet(name)
}

/**
 * Write data to the worksheet
 * @param {Workbook} workbook 
 * @param {string} sheetName 
 * @param {Object} data {columns: [
 * { header: '', key: '', width: 0, style: '' },
 * ], rows: [
 * { key: '', value: '' },]}
 */
async function writeToSheet(workbook, sheetName, data) {
  const sheet = workbook.getWorksheet(sheetName)
  sheet.columns = data.columns
  sheet.addRows(data.rows)
}


/**
 * Download the file to the user's browser
 * @param {Workbook} workbook 
 * @param {string} fileName
 */
async function downloadFile(workbook, fileName = 'export.xlsx') {
  console.log('downloading file');
  // await workbook.xlsx.writeFile(fileName)

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.download = fileName;
  link.href = url;
  link.click();
  console.log('file downloaded');
}

/**
 * 
 * @param {Object} data  {
 *  - columns: [
 *  - { header: '', key: '', width: 0, style: '' },
 *  - ], rows: [
 *  - { key: '', value: '' },
 *  - ]}
 * @param {string} sheetName
 * 
 */
async function exportToExcel(data) {
  const workbook = createWorkbook()
  addSheet(workbook, 'Sheet1')
  writeToSheet(workbook, 'Sheet1', data)
  downloadFile(workbook)
}

/**
 * 
 * @param {Workbook} workbook 
 */
async function exportSalesReport(workbook, from, to) {
  // const workbook = createWorkbook();
  const sheet = workbook.addWorksheet('Sales Report', {
    headerFooter: {
      firstFooter: "&C  Sales Report"
    }
  })
  const invoices = await db.getInvoices();
  const report = convertToGST_Sales_Report(invoices, from, to, true);
  console.log(report);

  // const keys = ['customerGST', 'customerName', 'pos', 'invoiceNo', 'billDate', 'gstRate', 'igst', 'cgst', 'sgst', 'amt', 'gstAmt', 'total', 'totalAmt', 'id'];
  const width = [20, 30, 25, 10, 12, 12, 11, 11, 11, 13, 13, 13, 14, 0];
  // report.header.push('ID')
  const columns = report.header.map((h, i) => {
    return {
      header: h,
      key: report.keys[i],
      width: width[i],
      name: h,
      totalsRowFunction: 'sum',
      filterButton: true,
    }
  });

  sheet.columns = columns
  // sheet.getColumn('id').hidden = true;
  sheet.addRows(report.data);
  sheet.addRow(report.totals)
  sheet.addRows(report.gstTotal)
  styleSheet(sheet);

  return {
    gstTotal: report.gstTotal,
    totals: report.totals,
  }

}


/**
 * 
 * @param {Workbook} workbook 
 */
async function exportPurchaseReport(workbook, from, to) {
  // const workbook = createWorkbook();
  const sheet = workbook.addWorksheet('Purchase Report', {
    headerFooter: {
      firstFooter: "&C  Sales Report"
    }
  })
  const invoices = await db.getPurchases();
  const report = convertToGST_Purchase_Report(invoices, from, to, true);
  console.log(report);

  // const keys = ['partyGST', 'partyName', 'pos', 'invoiceNo', 'billDate', 'gstRate', 'igst', 'cgst', 'sgst', 'amt', 'gstAmt', 'total', 'totalAmt'];
  const width = [20, 30, 25, 10, 12, 10, 11, 11, 11, 13, 13, 13, 14, 5];
  // report.header.push('ID')
  const columns = report.header.map((h, i) => {
    return {
      header: h,
      key: report.keys[i],
      width: width[i],
      name: h,
      totalsRowFunction: 'sum',
      filterButton: true,
    }
  });

  sheet.addRow(['GST PURCHASE REPORT'], { style: { bold: true } });
  sheet.columns = columns
  // sheet.getColumn('id').hidden = true;
  sheet.addRows(report.data);
  sheet.addRow(report.totals);
  sheet.addRows(report.gstTotal);
  styleSheet(sheet);


  return {
    gstTotal: report.gstTotal,
    totals: report.totals,
  }

}

/**
 * @param {Workbook} workbook
 */
async function exportAdjustmentsReport(workbook, from, to) {
  const adj = await calculate_Adjustments(from, to)
  const sheet = workbook.addWorksheet('GST Adjustments');
  sheet.columns = adj.adjustments.columns;
  sheet.addRows(adj.adjustments.data);

  const sheet2 = workbook.addWorksheet('Output GST Adjustments');
  sheet2.columns = adj.salesReports.columns;
  sheet2.addRows(adj.salesReports.data);

  const sheet3 = workbook.addWorksheet('Input GST Adjustments');
  sheet3.columns = adj.purchaseReports.columns;
  sheet3.addRows(adj.purchaseReports.data);
}



/**
 * 
 * @param {Workbook} workbook 
 */
async function exportReport(from = moment().subtract(1, 'months').format('YYYY-MM-DD'), to = moment().format('YYYY-MM-DD')) {
  const workbook = createWorkbook();
  const salesReport = await exportSalesReport(workbook, from, to);
  const purchaseReport = await exportPurchaseReport(workbook, from, to);
  const adjustments = await exportAdjustmentsReport(workbook, from, to);

  const fileName = `GST Report ${from} to ${to}`;
  downloadFile(workbook, fileName);
}


async function styleSheet(sheet) {
  const totalCount = sheet.rowCount - 4;
  const totalROw = sheet.getRow(totalCount)
  totalROw.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FF000000' },
    bgColor: { argb: 'FF000000' },
  };
  totalROw.font = { bold: true, color: { argb: 'FFFFFFFF' } };

  const frontRow = sheet.getRow(1)
  frontRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'ffaaaaaa' },
    bgColor: { argb: 'ffffffff' },
  };
  frontRow.font = { bold: true };
  frontRow.border = {
    top: { style: 'thin' },
    left: { style: 'thin' },
    bottom: { style: 'thin' },
    right: { style: 'thin' },
  };
}

export { createWorkbook, addSheet, writeToSheet, downloadFile, exportToExcel, exportReport }